import {DELETE_ALERT} from "../../../constants/MonitorConstants";
import {DeleteAlertMarketPayload, GeneralAction} from "../../../@types/actions";

export const DeleteAlertAction = (data: DeleteAlertMarketPayload): GeneralAction<DeleteAlertMarketPayload> => ({
    type: DELETE_ALERT,
    payload: data
});
